import { isPrivateView } from '../helpers'
import { viewVisibilityIndicators } from './constants'

const getSharedIndicator = count => {
  const indicator =
    count === 1 ? viewVisibilityIndicators.sharedWithOwnGroup : viewVisibilityIndicators.sharedWithGroups

  return { ...indicator, count }
}

export const getViewVisibilityIndicator = view => {
  if (view.isDefaultView) return viewVisibilityIndicators.predefined
  if (isPrivateView(view)) return viewVisibilityIndicators.private

  return getSharedIndicator(view.shared_with_groups.length)
}
